let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dMQ95")).then(() => parcelRequire('1hOxD'));